import { BasePaymentMethodsClient, PaymentMethod, PaymentMethodIdEnum } from "@core/types";
import { FortimePaymentMethodType } from "./types";

class PaymentMethodsClient extends BasePaymentMethodsClient {
  async getPaymentMethods(): Promise<PaymentMethod[]> {
    const response = await this.instance.get<FortimePaymentMethodType[]>("/wp-json/wc/v3/payment_gateways");
    const data: PaymentMethod[] = response.data.map(({ id, title, enabled }) => ({
      id,
      title,
      enabled,
      type: id === "bacs" ? PaymentMethodIdEnum.card : PaymentMethodIdEnum.cash,
    }));

    return data;
  }
}

export default PaymentMethodsClient;
